import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Typography } from '@mui/material';
import React from 'react';

export const DiagnosticsNotice: React.FC = () => {
  return (
    <Box
      sx={{
        p: 1.25,
        borderRadius: '8px',
        backgroundColor: '#f1f5f9',
        border: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <CheckCircleIcon sx={{ fontSize: 16, color: '#0F9A00', flexShrink: 0 }} />
      <Typography variant="caption" sx={{ color: '#475569', fontSize: '0.74rem', lineHeight: 1.3 }}>
        Page URL, browser info, console errors, and network queries will be attached automatically to assist debugging.
      </Typography>
    </Box>
  );
};
